import { useDictionaryContext } from "@/components/dictionaries/DictionaryContext";
import PageHeader from "@/components/PageHeader";
import { PATH_ROOT } from "@/constants";
import { ReadonlyObject } from "@/types/readOnly";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export default function DictionaryPageHeader<
  TRead extends ReadonlyObject,
  TWrite extends object,
>() {
  const { t } = useTranslation();
  const { id, config, query } = useDictionaryContext<TRead, TWrite>();
  const isNewRecord = id === "new";
  const labels = config.getLabels(t);
  const name = useMemo<string>(() => {
    if (query?.isLoading) {
      return "...";
    }
    if (query?.data) {
      const breadcrumbField = config.breadcrumbField || "name";
      if (breadcrumbField in query.data) {
        return String(query.data[breadcrumbField as keyof TRead]);
      }
    }
    return "";
  }, [query?.data, query?.isLoading, config.breadcrumbField]);

  const breadcrumbItems = useMemo(
    () => [
      { label: t("breadcrumb.home"), href: PATH_ROOT },
      { label: labels.dict, href: config.path },
      { label: isNewRecord ? labels.new : name },
    ],
    [config.path, isNewRecord, labels.dict, labels.new, name, t],
  );

  return <PageHeader breadcrumbItems={breadcrumbItems} />;
}
